import React, { useState } from 'react'
import { UPDATE_AGENT, UPDATE_USER } from '../graphql/mutation'
import { useMutation } from '@apollo/client'
import { GET_USER_BY_ID } from '../graphql/query'

interface IProps {
  data: any
  closeModal: () => void
}

const EditAgentOperatorProfile: React.FC<IProps> = ({ data, closeModal }) => {
  const [isName, setIsName] = useState<string>(data?.getUserById?.name)
  const [isDepartment, setIsDepartment] = useState<string>(data?.getUserById?.Department)
  const [updateAgent] = useMutation(UPDATE_AGENT, {
    refetchQueries: [
      {
        query: GET_USER_BY_ID,
        context: {
          headers: {
            'access-control-allow-methods': 'Profile'
          }
        }
      }
    ],
    context: {
      headers: {
        'access-control-allow-methods': 'Profile'
      }
    }
  })

  const handleSave = async () => {
    try {
      await updateAgent({
        variables: {
          input: {
            id: parseInt(data?.getUserById?.id),
            name: isName,
            Department: isDepartment
          }
        }
      })
    } catch (error) {
      console.error('Error updating name:', error)
    }
    closeModal()
  }

  return (
    <div>
      <h4 className='mb-5 text-center'>Update Profile</h4>
      <div className='d-flex flex-column'>
        <h4 className='mb-2'>Name</h4>
        <input
          className='form-control form-control-solid'
          name='headerTitle'
          value={isName}
          onChange={(e) => setIsName(e.target.value)}
        />
        <h4 className='mb-2 mt-8'>Department</h4>
        <input
          className='form-control form-control-solid'
          name='headerTitle'
          value={isDepartment}
          onChange={(e) => setIsDepartment(e.target.value)}
        />
        <div className='d-flex justify-content-end mt-8'>
          <button className='btn btn-secondary me-2' onClick={closeModal}>
            Cancel
          </button>
          <button className='btn btn-primary' onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  )
}

export default EditAgentOperatorProfile
